import { VROverlay } from './overlays.js';

export class VRSign extends VROverlay {
  constructor (vr, scene, options) {
    super(vr, scene, options);

    this.scene = scene;

    super.setType('sign');

    this.onRoomChange(this.vr.getRoomAsset());

    this.options.yaw = this.topLeftYawPitch.yaw;
    this.options.pitch = this.topLeftYawPitch.pitch;

    this.widthYaw = this.bottomRightYawPitch.yaw - this.topLeftYawPitch.yaw;
    this.heightPitch =
      this.topRightYawPitch.pitch - this.bottomLeftYawPitch.pitch;

    this.options.distance = 1;
    this.options.maxDistance = 1; // 0.6;
    this.options.minDistance = 1; // 6;

    this.width = 1168;
    this.height = 833;

    this.setImage(this.options.image);
    this.img.height('100%');

    this.handleTopLeft = $(
      '<div class="ca-vr_overlay_handle ca-vr_overlay_handle_topleft"></div>'
    );
    this.handleTopLeft.data('coordindex', 0);
    this.vr.container.append(this.handleTopLeft);

    this.handleTopRight = $(
      '<div class="ca-vr_overlay_handle ca-vr_overlay_handle_topright"></div>'
    );
    this.handleTopRight.data('coordindex', 1);
    this.vr.container.append(this.handleTopRight);

    this.handleBottomLeft = $(
      '<div class="ca-vr_overlay_handle ca-vr_overlay_handle_bottomleft"></div>'
    );
    this.handleBottomLeft.data('coordindex', 3);
    this.vr.container.append(this.handleBottomLeft);

    this.handleBottomRight = $(
      '<div class="ca-vr_overlay_handle ca-vr_overlay_handle_bottomright"></div>'
    );
    this.handleBottomRight.data('coordindex', 2);
    this.vr.container.append(this.handleBottomRight);
  }

  onRoomChange (room) {
    if (typeof this.options.coords === 'string') {
      this.coords = this.vr.getRoomAssetPlaceholderCoords(
        room.id,
        this.options.coords
      );
    } else this.coords = this.options.coords;

    this.initCoords();
  }

  initCoords () {
    if (this.coords == null) {
      this.hide();
      return;
    }

    this.show();

    this.topLeftYawPitch.yaw = this.coords[0][0];
    this.topLeftYawPitch.pitch = this.coords[0][1];
    this.topRightYawPitch.yaw = this.coords[1][0];
    this.topRightYawPitch.pitch = this.coords[1][1];
    this.bottomRightYawPitch.yaw = this.coords[2][0];
    this.bottomRightYawPitch.pitch = this.coords[2][1];
    this.bottomLeftYawPitch.yaw = this.coords[3][0];
    this.bottomLeftYawPitch.pitch = this.coords[3][1];
  }

  render (t) {
    if (!super.render(t)) return;
    this.moveHandles();
  }

  checkError () {
    const error = super.checkError();
    if (error !== 0 && this.options.id === 'overlay_fgdgdfyrdgdfgfd') { console.log('error: ' + error); }
    return error;
  }

  moveHandles () {
    if (!this.isEditMode() || !this.handleTopLeft) return;

    this.handleTopLeft.css('left', this.topLeft.x + 'px');
    this.handleTopLeft.css('top', this.topLeft.y + 'px');
    this.handleTopRight.css('left', this.topRight.x + 'px');
    this.handleTopRight.css('top', this.topRight.y + 'px');
    this.handleBottomLeft.css('left', this.bottomLeft.x + 'px');
    this.handleBottomLeft.css('top', this.bottomLeft.y + 'px');
    this.handleBottomRight.css('left', this.bottomRight.x + 'px');
    this.handleBottomRight.css('top', this.bottomRight.y + 'px');
  }

  setEditMode (editMode) {
    super.setEditMode(editMode);

    if (editMode) this.moveHandles();

    this.handleTopLeft.toggle(editMode);
    this.handleTopRight.toggle(editMode);
    this.handleBottomLeft.toggle(editMode);
    this.handleBottomRight.toggle(editMode);
  }

  move (x, y) {
    if (this.moving) {
      const diffX = x - this.mouseDownTopLeftYawPitch.yaw;
      const diffY = y - this.mouseDownTopLeftYawPitch.pitch;

      this.topLeftYawPitch.yaw = x;
      this.topLeftYawPitch.pitch = y;
      this.topRightYawPitch.yaw = this.mouseDownTopRightYawPitch.yaw + diffX;
      this.topRightYawPitch.pitch =
        this.mouseDownTopRightYawPitch.pitch + diffY;
      this.bottomRightYawPitch.yaw =
        this.mouseDownBottomRightYawPitch.yaw + diffX;
      this.bottomRightYawPitch.pitch =
        this.mouseDownBottomRightYawPitch.pitch + diffY;
      this.bottomLeftYawPitch.yaw =
        this.mouseDownBottomLeftYawPitch.yaw + diffX;
      this.bottomLeftYawPitch.pitch =
        this.mouseDownBottomLeftYawPitch.pitch + diffY;
    }
  }

  moveBy (x, y) {
    super.moveBy(x, y);
    this.move(
      this.mouseDownTopLeftYawPitch.yaw - x,
      this.mouseDownTopLeftYawPitch.pitch + y
    );
  }

  setPropId (propId) {
    this.options.propId = propId;
    this.div.addClass('ca-vr_overlay_' + this.options.type + '_' + propId);
  }

  getPropId () {
    return this.options.propId;
  }

  onToggleDayNight () {
    this.setPropId(this.getPropId());
  }

  setHeadingText () {}

  getHeadingText () {}
}
